import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveLandingPage } from "../api";
import { landingPagesKeys } from "../queries/index";
import type { LandingPageFormValues } from "../../types";

export const useSaveLandingPageMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: LandingPageFormValues) => {
      const response = await saveLandingPage(data);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.removeQueries({ queryKey: landingPagesKeys.all });
      if (variables.id) {
        queryClient.removeQueries({
          queryKey: landingPagesKeys.detail(variables.id),
        });
      }
    },
  });
};
